import { Home, Profile } from "./pages/dashboard";
import Product from "./pages/products/product";
import AddProduct from "./pages/products/add-product";
import Customer from "./pages/customers/customer";
import AddCustomer from "./pages/customers/add-customer";
import Category from "./pages/categories/category";
import EmailTemplate from "./pages/email-template/emailTemplate";
import RolePermission from "./pages/roles-and-permissions/role-permission";
import { ForgotPassword, ResetPassword, SignIn } from "./pages/auth";
import VerifyOTP from "./pages/auth/verify-otp";
import ListInternalUser from './pages/internal-users/list-internal-users';
import AddInternalUser from "./pages/internal-users/add-internal-users";
import AddBanner from "./pages/banners/add-banner";
import Office from "./pages/offices/office";
import AddOffice from "./pages/offices/add-office";
import BusinessType from "@/pages/type-management/business-type";
import AddBusinessType from "./pages/type-management/add-business-type";
import Banner from "./pages/banners/banner";
import Brand from "./pages/brands/brand";
import AddBrand from "./pages/brands/add-brand";
import AddEmailTemplate from "./pages/email-template/add-emailTemplate";
import ListMember from './pages/members/list-member';
import AddMember from './pages/members/add-member';
import Attribute from "./pages/attributes/attribute";
import AddAttribute from "./pages/attributes/add-attribute";
import AddCustomerMember from "./pages/customers/add-member";
import CustomerMember from "./pages/customers/member";
import RegisterVendor from "./pages/auth/register-vendor";
import Settings from "./pages/settings/app-setting";
import ViewInternalUser from "./pages/internal-users/view-internal-users";
import ListDeliveryPartners from "./pages/internal-users/list-delivery-partners";
import AddDeliveryPartners from "./pages/internal-users/add-delivery-partners";
import ViewDeliveryPartners from "./pages/internal-users/view-delivery-partners";
import ViewCustomer from "./pages/customers/view-customer";
import ViewProfile from "./pages/dashboard/view-profile";
import Rfq from "./pages/rfqs/rfqs";
import RfqDetails from "./pages/rfqs/rfq-details";
import ChatPage from "./pages/chats/chat";
import Order from "./pages/orders/orders";
import OrderItemsTracking from "./pages/orders/order-items-tracking";
import PaymentsDashboard from "./pages/payments/payments";
import SignUp from "./pages/delivery/delivery-auth/sign-up";
import AssignedDeliveryOverview from "./pages/delivery/delivery-dashboard/assigned-deliveries/assigned-delivery-overview";
import NewDeliveries from "./pages/delivery/delivery-dashboard/new-deliveries/new-deliveries";
import DeliveryHomePage from "./pages/delivery/delivery-dashboard/assigned-deliveries/home";
import NewDeliveryOverview from "./pages/delivery/delivery-dashboard/new-deliveries/new-delivery-overview";
import NotificationsPage from "./pages/delivery/delivery-dashboard/notifications";
import CollectProduct from "./pages/delivery/delivery-dashboard/assigned-deliveries/collect-product";
import ProofUpload from "./pages/delivery/delivery-dashboard/assigned-deliveries/proof-upload";
import EditProfile from "./pages/delivery/delivery-dashboard/edit-profile.jsx";
import CompletedOrderSummary from "./pages/delivery/delivery-dashboard/completed-deliveries/completed-order-summary.jsx";
import DropoffProduct from "./pages/delivery/delivery-dashboard/assigned-deliveries/drop-off-product";
import CompletedDeliveryOrder from "./pages/completed-delivery-orders/completed-delivery-orders";
import CompletedOrderItems from "./pages/completed-delivery-orders/completed-order-items";
import ManageAppointments from "./pages/appointments/manage-appointments";
import TicketList from "./pages/tickets/ticket-list";
import LeaveManagement from "./pages/leaves/leaves";
import PolicyForm from "./pages/settings/policy";
import AdminFeedbackList from "./pages/feedbacks/list-custumer-feedback";
import UserLeaveManagement from "./pages/leaves/users-leave";
import CreateAppointment from "./pages/appointments/create-appointment";
import CurrencyManagement from "./pages/currencies/CurrencyManagement";
import DeliveryProofUpload from "./pages/delivery/delivery-dashboard/assigned-deliveries/delivery-proof-upload";


export const getRoutes = (t) => [
  {
    layout: "dashboard",
    image: 'folder',
    pages: [
      {
        name: t("dashboard"),
        path: "/home",
        element: <Home />,
        permission: "dashboard.view"
      }
    ],
  },
  {
    unique_key: 'rfq',
    layout: "dashboard",
    image: 'users',
    pages: [
      {
        name: t("rfqManagement"),
        path: "/rfqs",
        element: <Rfq />,
        permission: "rfq.view"
      }
    ],
  },
  {
    unique_key: 'order',
    layout: "dashboard",
    image: 'order-list',
    pages: [
      {
        name: t("manageOrders"),
        path: "/orders",
        element: <Order />,
        permission: "order.view"
      }
    ],
  },
  {
    unique_key: 'order',
    layout: "dashboard",
    image: 'order-list',
    pages: [
      {
        name: t("completedDeliveries"),
        path: "/completed-delivery-orders",
        element: <CompletedDeliveryOrder />,
        permission: "order.view"
      }
    ],
  },
  {
    unique_key: 'customer',
    layout: "dashboard",
    image: 'user',
    pages: [
      {
        name: t("customerList"),
        path: "/customers",
        element: <Customer type={"Customer"} />,
        permission: "customer.view"
      }
    ],
  },
  {
    unique_key: 'vendor',
    layout: "dashboard",
    image: 'headset-one',
    pages: [
      {
        name: t("vendorList"),
        path: "/vendors",
        element: <Customer type={"Vendor"} />,
        permission: 'vendor.view'
      }
    ],
  },
  {
    unique_key: 'sub_admin',
    layout: "dashboard",
    image: 'user',
    pages: [
      {
        name: t("subAdmin"),
        path: '/sub-admin',
        element: <ListInternalUser type={'Sub Admin'} />,
        permission: 'sub-admin.view'
      },
    ],
  },
  {
    unique_key: 'internal_user',
    title: t("internalUsers"),
    image: 'user',
    layout: "dashboard",
    pages: [
      {
        name: t("cityRepresentative"),
        path: '/city-representative',
        element: <ListInternalUser type={'City Representative'} />,
        permission: 'city-representative.view'
      },
      {
        name: t("salesRepresentative"),
        path: '/sales-representative',
        element: <ListInternalUser type={'Sales Representative'} />,
        permission: 'sales-representative.view'
      },
      {
        name: t("finance"),
        path: '/finance',
        element: <ListInternalUser type={'Finance'} />,
        permission: 'finance.view'
      },
      {
        name: t("deliveryPartner"),
        path: '/delivery-partner',
        element: <ListDeliveryPartners />,
        permission: 'delivery-partner.view'
      },
      {
        name: t("procurement"),
        path: '/procurement',
        element: <ListInternalUser type={'Procurement'} />,
        permission: 'procurement.view'
      }
    ]
  },
  {
    layout: "dashboard",
    image: 'chat-comment',
    pages: [
      {
        name: t("chat"),
        path: '/chat',
        element: <ChatPage />,
        permission: 'chat.view'
      },
    ],
  },
  {
    layout: "dashboard",
    image: 'category-management',
    pages: [
      {
        name: t("categoryList"),
        path: "/categories",
        element: <Category />,
        permission: 'category.view'
      }
    ],
  },
  {
    unique_key: 'product',
    layout: "dashboard",
    image: 'grids',
    pages: [
      {
        name: t("productList"),
        path: "/products",
        element: <Product />,
        permission: 'product.view'
      }
    ],
  },
  {
    layout: "dashboard",
    image: 'grids',
    pages: [
      {
        name: t("rolesAndPermissions"),
        path: "/roles-and-permissions",
        element: <RolePermission />,
        permission: 'role-permission.view'
      }
    ],
  },
  {
    layout: "dashboard",
    image: 'headset-one',
    pages: [
      {
        name: t("payments"),
        path: "/payments",
        element: <PaymentsDashboard />,
        permission: 'payment.view'
      }
    ],
  },
  {
    unique_key: 'appointments',
    layout: "dashboard",
    image: 'user',
    pages: [
      {
        name: t("manageAppointments"),
        path: '/appointments',
        element: <ManageAppointments />,
        permission: 'appointment.view'
      },
      {
        name: t("createAppointment"),
        path: '/create-appointment',
        element: <CreateAppointment />,
        permission: 'appointment.add'
      }
    ],
  },
  {
    layout: "dashboard",
    image: 'headset-one',
    pages: [
      {
        name: t("ticketsManagement"),
        path: "/tickets",
        element: <TicketList />,
        permission: 'ticket.view'
      }
    ],
  },
  {
    unique_key: 'leaves',
    layout: "dashboard",
    image: 'user',
    pages: [
      {
        name: t("applyLeave"),
        path: '/leaves',
        element: <LeaveManagement />,
      },
    ],
  },
  {
    unique_key: 'user-leaves',
    layout: "dashboard",
    image: 'users',
    pages: [
      {
        name: t("leaveManagement"),
        path: '/user-leaves',
        element: <UserLeaveManagement />,
        // permission:'user-leave.view'
      },
    ],
  },
  {
    unique_key: 'feedbacks',
    layout: "dashboard",
    image: 'user',
    pages: [
      {
        name: t("feedback"),
        path: '/feedback',
        element: <AdminFeedbackList />,
        // permission:'feedback.view'
      },
    ],
  },
  {
    title: t("configuration"),
    image: "setting",
    layout: "dashboard",
    pages: [
      {
        name: t("bannersList"),
        path: "/banners",
        element: <Banner />,
        permission: "banner.view",
      },
      {
        name: t("brandsList"),
        path: "/brands",
        element: <Brand />,
        permission: "brand.view",
      },
      {
        name: t("emailTemplate"),
        path: "/email-templates",
        element: <EmailTemplate />,
        permission: "email-template.view",
      },
      {
        name: t("officeList"),
        path: "/offices",
        element: <Office />,
        permission: "office.view",
      },
      {
        name: t("productAttributes"),
        path: "/attributes",
        element: <Attribute />,
        permission: "product-attribute.view",
      },
      {
        name: t("businessType"),
        path: "/business-types",
        element: <BusinessType type={"business"} />,
        permission: "business-type.view",
      },
      {
        name: t("vendorType"),
        path: "/vendor-types",
        element: <BusinessType type={"vendor"} />,
        permission: "vendor-type.view",
      },
      {
        name: t("privacyPolicy"),
        path: "/privacy-policy",
        element: <PolicyForm type={'privacy'} />,
        permission: "privacy-policy.view",
      },
      {
        name: t("termsAndConditions"),
        path: "/terms-conditions",
        element: <PolicyForm type={'terms'} />,
        permission: "terms-&-conditions.view",
      },
      {
        name: t("settings"),
        path: "/setings",
        element: <Settings />,
        permission: "setting.view",
      },
      {
        name: t("currencyManagement"),
        path: "/currency-management",
        element: <CurrencyManagement />,
        // permission: "currency-management.view",
      },

    ],
  },
  // guest pages
  {
    title: "",
    layout: "auth",
    pages: [
      {
        name: t("signIn"),
        path: "/",
        element: <SignIn />,
      },
      {
        name: t("signIn"),
        path: "/sign-in",
        element: <SignIn />,
      },
      {
        name: t("forgotPassword"),
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        name: t("resetPassword"),
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        name: t("verifyOTP"),
        path: "/verify-otp",
        element: <VerifyOTP />,
      },
      {
        name: t("registerVendor"),
        path: "/vendor/register",
        element: <RegisterVendor />,
      },
    ],
  },
  {
    title: "",
    layout: "delivery-auth",
    pages: [
      {
        name: t("signUp"),
        path: "/sign-up",
        element: <SignUp />,
      },
    ],
  },
  // hidden dashboard sub menus
  {
    title: '',
    layout: 'dashboard',
    pages: [
      {
        name: t("profile"),
        path: "/profile",
        element: <ViewProfile />,
      },
      {
        name: t("profile"),
        path: "/profile/edit",
        element: <Profile />,
      },
      {
        name: t("addCustomer"),
        path: "customers/add",
        element: <AddCustomer type={'Customer'} />,
        permission: 'customer.add'
      },
      {
        name: t("editCustomer"),
        path: "customers/edit/:id",
        element: <AddCustomer type={'Customer'} isEdit={true} />,
        permission: 'customer.update'
      },
      {
        name: t("viewCustomer"),
        path: "customers/view/:id",
        element: <ViewCustomer type={'Customer'} />,
        permission: 'customer.view'
      },
      {
        name: t("customerTeamMembers"),
        path: "customer-members/:id",
        element: <CustomerMember type={'Customer'} />,
        permission: 'customer.view'
      },
      {
        name: t("addCustomerTeamMember"),
        path: "customer-members/add",
        element: <AddCustomerMember type={'Customer'} />,
        permission: 'customer.add'
      },
      {
        name: t("editCustomerTeamMember"),
        path: "customer-members/edit/:id",
        element: <AddCustomerMember type={'Customer'} isEdit={true} />,
        permission: 'customer.update'
      },
      {
        name: t("viewCustomerTeamMember"),
        path: "customer-members/view/:id",
        element: <AddCustomerMember type={'Customer'} isEdit={true} isView={true} />,
        permission: 'customer.view'
      },
      {
        name: t("addVendor"),
        path: "vendors/add",
        element: <AddCustomer type={'Vendor'} />,
        permission: 'vendor.add'
      },
      {
        name: t("editVendor"),
        path: "vendors/edit/:id",
        element: <AddCustomer type={'Vendor'} isEdit={true} />,
        permission: 'vendor.update'
      },
      {
        name: t("viewVendor"),
        path: "vendors/view/:id",
        element: <ViewCustomer type={'Vendor'} />,
        permission: 'vendor.view'
      },
      {
        name: t("addProduct"),
        path: "/products/add",
        element: <AddProduct />,
        permission: 'product.add'
      },
      {
        name: t("editProduct"),
        path: "/products/edit/:id",
        element: <AddProduct isEdit={true} />,
        permission: 'product.update'
      },
      {
        name: t("viewProduct"),
        path: "/products/view/:id",
        element: <AddProduct isEdit={true} isView={true} />,
        permission: 'product.view'
      },
      {
        name: t("addSalesRepresentative"),
        path: "/sales-representative/add",
        element: <AddInternalUser type={'Sales Representative'} />,
        permission: 'sales-representative.add'
      },
      {
        name: t("editSalesRepresentative"),
        path: "/sales-representative/edit/:id",
        element: <AddInternalUser type={'Sales Representative'} isEdit={true} />,
        permission: 'sales-representative.update'
      },
      {
        name: t("viewSalesRepresentative"),
        path: "/sales-representative/view/:id",
        element: <ViewInternalUser type={'Sales Representative'} />,
        permission: 'sales-representative.view'
      },
      {
        name: t("addCityRepresentative"),
        path: "/city-representative/add",
        element: <AddInternalUser type={'City Representative'} />,
        permission: 'city-representative.add'
      },
      {
        name: t("editCityRepresentative"),
        path: "/city-representative/edit/:id",
        element: <AddInternalUser type={'City Representative'} isEdit={true} />,
        permission: 'city-representative.update'
      },
      {
        name: t("viewCityRepresentative"),
        path: "/city-representative/view/:id",
        element: <ViewInternalUser type={'City Representative'} />,
        permission: 'city-representative.view'
      },
      {
        name: t("addFinance"),
        path: "/finance/add",
        element: <AddInternalUser type={'Finance'} />,
        permission: 'finance.add'
      },
      {
        name: t("editFinance"),
        path: "/finance/edit/:id",
        element: <AddInternalUser type={'Finance'} isEdit={true} />,
        permission: 'finance.update'
      },
      {
        name: t("viewFinance"),
        path: "/finance/view/:id",
        element: <ViewInternalUser type={'Finance'} />,
        permission: 'finance.view'
      },
      {
        name: t("addSubAdmin"),
        path: "/sub-admin/add",
        element: <AddInternalUser type={'Sub Admin'} />,
        permission: 'sub-admin.add'
      },
      {
        name: t("editSubAdmin"),
        path: "/sub-admin/edit/:id",
        element: <AddInternalUser type={'Sub Admin'} isEdit={true} />,
        permission: 'sub-admin.update'
      },
      {
        name: t("viewSubAdmin"),
        path: "/sub-admin/view/:id",
        element: <ViewInternalUser type={'Sub Admin'} />,
        permission: 'sub-admin.view'
      },
      {
        name: t("addDeliveryPartner"),
        path: "delivery-partner/add",
        element: <AddDeliveryPartners />,
        permission: "delivery-partner.add"
      },
      {
        name: t("editDeliveryPartner"),
        path: "delivery-partner/edit/:id",
        element: <AddDeliveryPartners />,
        permission: "delivery-partner.update"
      },
      {
        name: t("viewDeliveryPartner"),
        path: "delivery-partner/view/:id",
        element: <ViewDeliveryPartners />,
        permission: "delivery-partner.view"
      },
      {
        name: t("addProcurement"),
        path: "procurement/add",
        element: <AddInternalUser type={'Procurement'} />,
        permission: 'procurement.add'
      },
      {
        name: t("editProcurement"),
        path: "/procurement/edit/:id",
        element: <AddInternalUser type={'Procurement'} isEdit={true} />,
        permission: 'procurement.update'
      },
      {
        name: t("viewProcurement"),
        path: "/procurement/view/:id",
        element: <ViewInternalUser type={'Procurement'} />,
        permission: 'procurement.view'
      },
      {
        name: t("members"),
        path: "/members",
        element: <ListMember />,
        permission: 'member.view'
      },
      {
        name: t("addMember"),
        path: "members/add",
        element: <AddMember />,
        permission: 'member.add'
      },
      {
        name: t("editMember"),
        path: "/members/edit/:id",
        element: <AddMember isEdit={true} />,
        permission: 'member.update'
      },
      {
        name: t("viewMember"),
        path: "/members/view/:id",
        element: <AddMember isEdit={true} isView={true} />,
        permission: 'member.view'
      },
      {
        name: t("addBanner"),
        path: "/banners/add",
        element: <AddBanner />,
        permission: 'banner.add'
      },
      {
        name: t("editBanner"),
        path: "/banners/edit/:id",
        element: <AddBanner isEdit={true} />,
        permission: 'banner.update'
      },
      {
        name: t("viewBanner"),
        path: "/banners/view/:id",
        element: <AddBanner isEdit={true} isView={true} />,
        permission: 'banner.view'
      },
      {
        name: t("addBrand"),
        path: "/brands/add",
        element: <AddBrand />,
        permission: 'brand.add'
      },
      {
        name: t("editBrand"),
        path: "/brands/edit/:id",
        element: <AddBrand isEdit={true} />,
        permission: 'brand.update'
      },
      {
        name: t("viewBrand"),
        path: "/brands/view/:id",
        element: <AddBrand isEdit={true} isView={true} />,
        permission: 'brand.view'
      },
      {
        name: t("addOffice"),
        path: "/offices/add",
        element: <AddOffice />,
        permission: 'office.add'
      },
      {
        name: t("editOffice"),
        path: "/offices/edit/:id",
        element: <AddOffice isEdit={true} />,
        permission: 'office.update'
      },
      {
        name: t("viewOffice"),
        path: "/offices/view/:id",
        element: <AddOffice isEdit={true} isView={true} />,
        permission: 'office.view'
      },
      {
        name: t("addBusinessType"),
        path: "/business-types/add",
        element: <AddBusinessType type={'business'} />,
        permission: 'business-type.add'
      },
      {
        name: t("editBusinessType"),
        path: "/business-types/edit/:id",
        element: <AddBusinessType type={'business'} isEdit={true} />,
        permission: 'business-type.update'
      },
      {
        name: t("viewBusinessType"),
        path: "/business-types/view/:id",
        element: <AddBusinessType type={'business'} isEdit={true} isView={true} />,
        permission: 'business-type.view'
      },
      {
        name: t("addVendorType"),
        path: "/vendor-types/add",
        element: <AddBusinessType type={'vendor'} />,
        permission: 'vendor-type.add'
      },
      {
        name: t("editVendorType"),
        path: "/vendor-types/edit/:id",
        element: <AddBusinessType type={'vendor'} isEdit={true} />,
        permission: 'vendor-type.update'
      },
      {
        name: t("viewVendorType"),
        path: "/vendor-types/view/:id",
        element: <AddBusinessType type={'vendor'} isEdit={true} isView={true} />,
        permission: 'vendor-type.view'
      },
      {
        name: t("addEmailTemplate"),
        path: "/email-templates/add",
        element: <AddEmailTemplate />,
        permission: 'email-template.add'
      },
      {
        name: t("editEmailTemplate"),
        path: "/email-templates/edit/:id",
        element: <AddEmailTemplate isEdit={true} />,
        permission: 'email-template.update'
      },
      {
        name: t("viewEmailTemplate"),
        path: "/email-templates/view/:id",
        element: <AddEmailTemplate isEdit={true} isView={true} />,
        permission: 'email-template.view'
      },
      {
        name: t("addAttribute"),
        path: "/attributes/add",
        element: <AddAttribute />,
        permission: 'product-attribute.add'
      },
      {
        name: t("editAttribute"),
        path: "/attributes/edit/:id",
        element: <AddAttribute isEdit={true} />,
        permission: 'product-attribute.update'
      },
      {
        name: t("viewAttribute"),
        path: "/attributes/view/:id",
        element: <AddAttribute isEdit={true} isView={true} />,
        permission: 'product-attribute.view'
      },
      {
        name: t("rfqItems"),
        path: "/rfqs/:id",
        element: <RfqDetails />,
        permission: 'rfq.view'
      },
      {
        name: t("orderItems"),
        path: "/orders/:id",
        element: <OrderItemsTracking />,
        permission: 'order.view'
      },
      {
        name: t("completedDeliveries"),
        path: "/completed-delivery-orders/:id",
        element: <CompletedOrderItems />,
        // permission: 'order.view'
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("newDeliveries"),
        path: "/new-deliveries",
        element: <NewDeliveries />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("dashboard"),
        path: "/home",
        element: <DeliveryHomePage />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("newDelivery"),
        path: "/new-delivery/:id",
        element: <NewDeliveryOverview />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("assignedDelivery"),
        path: "/assigned-delivery/:id",
        element: <AssignedDeliveryOverview />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("assignedVendorDetails"),
        path: "/assigned-delivery/:order_id/:vendor_id/collect",
        element: <CollectProduct />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("assignedVendorDetails"),
        path: "/assigned-delivery/:id/dropoff",
        element: <DropoffProduct />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("proofUpload"),
        path: "/proof-upload/:id",
        element: <ProofUpload />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("deliveryProofUpload"),
        path: "/delivery-proof-upload/:id",
        element: <DeliveryProofUpload />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("notifications"),
        path: "/notifications",
        element: <NotificationsPage />,
      },
    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("editProfile"),
        path: "/edit-profile",
        element: <EditProfile />,
      },

    ]
  },
  {
    title: '',
    layout: 'delivery-partner',
    pages: [
      {
        name: t("completedOrderSummary"),
        path: "/completed-summary/:id",
        element: <CompletedOrderSummary />,
      },
    ]
  },
];
